import BigNumber from "bignumber.js";

export function toMoney(amount, currency = '€') {

    return new BigNumber(amount).toFixed(2) + " " + currency;
}
